import styled from 'styled-components';

export const StyledTbmStatusDashboard = styled.div`
  padding: 28px;
`;

export const StyledDivider = styled.div<{ color: string }>`
  border: 0.99px solid ${(props) => props.color};
`;

export const StyledTks = styled.div<{ color: string; labelColor?: string }>`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: center;
  background-color: #fff;
  padding: 8px 0px;
  border-radius: 4px;

  > div {
    color: ${(props) => props.color};
  }

  > div:first-child {
    font-size: 22px;
    font-weight: 500;
  }

  > div:last-child {
    font-size: 10px;
    font-weight: 500;
    color: ${(props) => props.labelColor || props.color};
  }
`;

export const Row = styled.div<{ gap?: string; justifyContent?: string }>`
  display: flex;
  justify-content: ${(props) => props.justifyContent || 'center'};
  align-items: center;
  gap: ${(props) => props.gap || '0'};
`;

export const Column = styled.div<{ gap?: string; alignItems?: string }>`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.gap || '0'};
  align-items: ${(props) => props.alignItems || 'stretch'};
`;
